module.exports = __webpack_public_path__ + "static/media/SanlamLogo.2a93c7fb.png";